<script setup>
import DashboardNavBar from "@/components/Layout/DashboardNavBar.vue";
import {ModalsContainer} from "vue-final-modal";
import {useNotificationStore} from "@/stores/notifications.js";
import ANotification from "@/components/AComponents/ANotification.vue";
import {onBeforeMount} from "vue";
import {useRoute, useRouter} from "vue-router";
import {useLoadingStore} from "@/stores/loading.js";

const route = useRoute();
const router = useRouter();

const loadingStore = useLoadingStore();
const notificationStore = useNotificationStore();

onBeforeMount(() => {
  if(route.query.checked_out === '1') {
    const query = { ...route.query };
    delete query.checked_out;
    router.replace({ query });

    notificationStore.showMessage(
      'It might take a few moments for your account limits and features to be updated.'
    );
  }
});
</script>

<template>
  <div class="flex min-h-[100vh] text-neutral-100">
    <dashboard-nav-bar />
    <main class="bg-neutral-300 p-8 flex-1 text-neutral-800 relative">
      <div v-if="loadingStore.loading" class="h-2 -ml-8 top-0 bg-gray-900 fixed z-99 transition-[width]"
           :style="{width: `${loadingStore.progress}%`}"></div>
      <slot />
      <div class="fixed bottom-8 right-8 z-9999">
        <a-notification v-for="notification in notificationStore.notifications"
                        :notification="notification"
                        :key="notification.id" />
      </div>
    </main>
    <modals-container />
  </div>
</template>
